import { render, staticRenderFns } from "./UpdatePlanComparisonsListModal.vue?vue&type=template&id=e403bc70&"
import script from "./UpdatePlanComparisonsListModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePlanComparisonsListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports